module.exports = __webpack_public_path__ + "aaef143a338d4cd0b464157240c78f5c.svg";